import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { openModal } from "risa-oasis-ui_v2";
import {
  DetailsCard,
  type DetailsCardData,
} from "../../../../components/detailsCard/detailsCard";
import ImageviewerModal from "../../../../components/modals/imageViewerModal/imageviewerModal";
import { usePayerNameContextFromSingleOrderLayout } from "../../../../context/payerNameContextFromSingleOrderLayout";
import { SubmissionStatusEnum } from "../../../../data-model/submissionDocs";
import { ScreenNamesForBigQuery } from "../../../../enums/eventsData";
import { EventsName } from "../../../../enums/eventsName";
import { ModalId } from "../../../../enums/modalId";
import {
  closeModal,
  setOpenedModalId,
} from "../../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../../redux/store/store";
import EyeIcon from "../../../../svg/eye";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";
import { useRefreshFaxStatus } from "../../hooks/useRefreshFaxStatus";

import { apiWorkerManager } from "../../../../workerManagers/workerManager";
interface AuthInfoComponentProps {
  serviceReviewInfo?: DetailsCardData[];
  docDownloadUrl?: string;
  submissionStatus?: SubmissionStatusEnum;
}

const AuthInfoComponent = (props: AuthInfoComponentProps) => {
  const { id } = useParams();
  const { openedModalId } = useSelector((state: RootState) => state.modal);
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );
  const orgId = getOrgIdForFetchExternalWorklist();
  const { singleMedicalPaOrder } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );

  const { payerName } = usePayerNameContextFromSingleOrderLayout();

  useRefreshFaxStatus({
    orderId: id,
  });

  useEffect(() => {
    if (openedModalId === ModalId.IMAGE_VIEWER_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_MODAL);
    }
  }, [openedModalId]);
  return (
    <div className="submission-auth-info--container flex flex-col gap-2">
      {singleMedicalPaOrder?.status?.fax_submission_status && (
        <div className="submission-auth-info--refresh-section flex flex-col gap-2"></div>
      )}
      <div className="submission-auth-info--header flex justify-between">
        <div className="submission-auth-info__heading text-small font-bold text-primaryGray-1">
          Auth Information
        </div>
        {(props?.submissionStatus === "completed" ||
          props?.submissionStatus === "error") && (
          <>
            <div className="submission-auth-info__sub-heading">
              <div
                className="document-card--icon flex items-center gap-1 text-small font-semibold text-tertiaryBlue-4 hover:cursor-pointer"
                onClick={() => {
                  dispatch(
                    setOpenedModalId({ id: ModalId.IMAGE_VIEWER_MODAL }),
                  );
                  apiWorkerManager.enqueueAndProcess({
                    patient_id: singleMedicalPaOrder?.patient_id ?? "",
                    order_id: singleMedicalPaOrder?.order_id ?? "",
                    org_id: orgId ?? "",
                    event_name: EventsName.VIEW_SCREENSHOT_CLICKED,
                    user_id: user?.id ?? "",
                    user_email: user?.email ?? "",
                    additional_data: {
                      screen_name:
                        ScreenNamesForBigQuery.SUBMISSION_STATUS_SCREEN,
                      submission_status: props?.submissionStatus ?? "",
                      form_id:
                        singleMedicalPaOrder?.selected_form_id_for_submission ??
                        "",
                      payer_name: payerName,
                      screenshot_path: props?.docDownloadUrl ?? "",
                    },
                  });
                }}
              >
                <EyeIcon />
                View Screenshot
              </div>
            </div>
          </>
        )}
      </div>
      <div className="submission-auth-info--body">
        <DetailsCard
          details={props?.serviceReviewInfo ?? []}
          elementsInOneRow={3}
          showBorder={true}
        />
      </div>
      {openedModalId === ModalId.IMAGE_VIEWER_MODAL && (
        <ImageviewerModal
          fileUrls={[]}
          filePaths={[props?.docDownloadUrl ?? ""]}
          onClose={() => {
            dispatch(closeModal());
          }}
        />
      )}
    </div>
  );
};

export default AuthInfoComponent;
